// src/features/patient/records/utils/liveUploadEvents.ts
//
// Live change messages for uploads and syncs (connection plan step 5). The
// database announces every real change to an upload, its page progress, a
// sync, an identity check or a deleted upload (backend alembic e8b4c2f6a1d9),
// and the API relays it over the existing socket to the people who may see
// that profile. Messages carry ids only; the screen then fetches just that
// upload or sync.

export const UPLOAD_CHANGED_EVENT = "upload:changed";
export const SYNC_CHANGED_EVENT = "sync:changed";

/** Once live messages are known to arrive for an upload, its poll only backs them up at this pace. */
export const LIVE_BACKUP_POLL_MS = 15_000;

export interface LiveChange {
  /** The upload's (or sync job's) id. */
  id: string;
  /** The table that changed: upload_jobs, document_extraction_status, document_page_extractions,
   *  upload_identity_checks, upload_deletions, direct_api_sync_jobs. */
  kind: string;
  op: "INSERT" | "UPDATE" | "DELETE";
  /** The profile it belongs to (a family member's, or the patient's own). */
  profile: string;
}

/** What an open upload panel is told about its upload. */
export type UploadSignal = "changed" | "offline";

export function isLiveChange(data: unknown): data is LiveChange {
  const value = data as Partial<LiveChange> | null;
  return Boolean(value && typeof value.id === "string" && typeof value.kind === "string"
    && typeof value.op === "string" && typeof value.profile === "string");
}

/** The upload (or sync) is gone: deleted after "not me", or its row removed. */
export function isRemoval(change: LiveChange): boolean {
  return change.kind === "upload_deletions" || (change.kind === "upload_jobs" && change.op === "DELETE");
}
